import React, { Dispatch, SetStateAction } from 'react';
import {
  Box,
  Button, CardActions,
  CardContent,
  Checkbox,
  Dialog,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';

function FeedbackFiltersDialog({
  open, setOpen, appliedFilters, setAppliedFilters, showCareType, showAnimalType,
}: {
  open: boolean,
  setOpen: Dispatch<SetStateAction<boolean>>,
  appliedFilters: Record<string, boolean>,
  setAppliedFilters: Dispatch<SetStateAction<Record<string, boolean>>>
  showCareType: boolean,
  showAnimalType: boolean,
}) {
  const [temporalFilters, setTemporalFilters] = React.useState(appliedFilters);

  const handleClose = () => {
    setOpen(false);
    setTemporalFilters(appliedFilters);
  };

  const applyFilters = () => {
    setOpen(false);
    setAppliedFilters(temporalFilters);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="filter-dialog-title"
      aria-describedby="filter-dialog-description"
      PaperProps={{
        sx: {
          width: '600px',
          maxWidth: '90vw',
        },
      }}
      maxWidth={false}
    >
      <DialogTitle id="logout-dialog-title">
        <Typography variant="h6bold">Filters</Typography>
      </DialogTitle>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            gap: 3,
            alignItems: 'top',
          }}
        >
          {showCareType && (
            <FormGroup sx={{ flexGrow: 1 }}>
              <Typography variant="body1" sx={{ color: 'secondary.text' }}>Relationship</Typography>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={temporalFilters?.adopted}
                    onChange={(e) => setTemporalFilters((prev) => ({ ...prev, adopted: e.target.checked }))}
                  />
                )}
                label="Adopted pets"
              />
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={temporalFilters?.fostered}
                    onChange={(e) => setTemporalFilters((prev) => ({ ...prev, fostered: e.target.checked }))}
                  />
                )}
                label="Fostered pets"
              />
            </FormGroup>
          )}
          {showAnimalType && (
            <FormGroup sx={{ flexGrow: 1 }}>
              <Typography variant="body1" sx={{ color: 'secondary.text' }}>Species</Typography>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={temporalFilters?.dogs}
                    onChange={(e) => setTemporalFilters((prev) => ({ ...prev, dogs: e.target.checked }))}
                  />
                )}
                label="Dogs"
              />
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={temporalFilters?.cats}
                    onChange={(e) => setTemporalFilters((prev) => ({ ...prev, cats: e.target.checked }))}
                  />
                )}
                label="Cats"
              />
            </FormGroup>
          )}
        </Box>
      </CardContent>
      <CardActions>
        <Button variant="contained" onClick={applyFilters}>Save Changes</Button>
        <Button onClick={handleClose}>Cancel</Button>
      </CardActions>
    </Dialog>
  );
}

export default FeedbackFiltersDialog;
